export default "__VITE_ASSET__552905e2__"